import ProjectTaskStatus from '../../pages/project-management-pmr/shared/enums/project-task-status'

export interface IProjectTaskStatus {
  name: string
  code: ProjectTaskStatus
  disabled: boolean
  tooltipMessage: string
}

export const getFlexTaskStatusList = (isAdhoc: boolean | null): IProjectTaskStatus[] => {
  let items = []
  items.push({
    name: 'Not Scheduled',
    code: ProjectTaskStatus.NotScheduled,
    disabled: false,
    tooltipMessage: '',
  })
  if (isAdhoc) {
    items.push({
      name: 'Not Started',
      code: ProjectTaskStatus.NotStarted,
      disabled: false,
      tooltipMessage: '',
    })
  }
  items.push({
    name: 'In Progress',
    code: ProjectTaskStatus.InProgress,
    disabled: false,
    tooltipMessage: 'This task will only progress once its Start Date commences.',
  })
  items.push({
    name: 'On Hold',
    code: ProjectTaskStatus.OnHold,
    disabled: false,
    tooltipMessage: '',
  })
  items.push({
    name: 'Cancelled',
    code: ProjectTaskStatus.Cancelled,
    disabled: false,
    tooltipMessage: 'Cannot cancel tasks with logged time entry.',
  })
  items.push({
    name: 'Discontinued',
    code: ProjectTaskStatus.Discontinued,
    disabled: false,
    tooltipMessage: '',
  })

  return items
}
